module.exports = __webpack_public_path__ + "img/f3-2.adf9dc67.png";